import {Autocomplete, TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import {FaSearchLocation} from "react-icons/fa";
import React, {useMemo} from "react";

const AutoCompleteRegions = ({selectedCity, setSearch, selectedRegion, search, sortOption}) => {

  const filteredData = useMemo(() => {
    const searchTerm = search.toLowerCase() || ""
    if (selectedCity[0] === "Total") return
    const cityNames = sortOption === 'default' ? selectedCity.map(item => item[0].split(" - ")[0]) : selectedCity.map(item  => item[0])
    return cityNames.filter(item => item.toLowerCase().includes(searchTerm))
  }, [selectedCity, search,  sortOption])



  return (
    <Autocomplete
      className="shadow "
      freeSolo
      id="free-solo-2-demo"
      disableClearable
      options={filteredData ? filteredData : []}
      onChange={(event, value) => setSearch(value)}
      onInputChange={(event, value) => {
        setSearch(value)
      }}
      openOnFocus
      renderInput={(params) => (
        <TextField
          {...params}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          label={`Pesquisar ${selectedRegion}`}
          variant="outlined"
          fullWidth
          InputProps={{
            ...params.InputProps,
            type: 'search',
            endAdornment: (
              <InputAdornment position="start">
                <FaSearchLocation className="md:text-xl text-md mx-2 text-emerald-700"/>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}

export default AutoCompleteRegions